// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalComponentPortal_modal__IBRAE","modal_content":"ModalComponentPortal_modal_content__26uXz"};